import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import {AuthService} from '@services/auth.service';
import {Api} from '../../../utils';

import {FormValidationService} from '@services/form-validation.service';
import {User} from "@models/user.interface";

@Component({
  selector: 'ms-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  progress: boolean = false;
  loginForm: FormGroup;
  submitted = false;
  status401: boolean  = false;
  loginvar: string;
  error: string;
  showOverlay: boolean = false;

  constructor(
    private auth: AuthService,
    private router: Router,
    private api: Api,
    private formValidation: FormValidationService,
  ) {}


  ngOnInit() {
    this.loginForm = this.generateForm();
  }


  login() {
    this.router.navigate(['/']);
    this.loginvar = this.api.getUrl('auth/login');
    if (!this.loginForm.valid) {
      this.submitted = true;
    } else {

      this.showOverlay = true;
      this.auth.login(this.loginForm.value.email, this.loginForm.value.password)
        .subscribe((data: User) => {
          this.showOverlay = false;
        }, (error): any => {
          this.showOverlay = false;
          this.error = error.error.message;
          return Observable.throw('Internal server error');
        });
    }
  }

  generateForm(): FormGroup {
    return new FormGroup({
      email: new FormControl(
        '', [Validators.required, Validators.email]
      ),
      password: new FormControl('', Validators.required),
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/authentication/login/login.component.ts